/* eslint-disable max-len,no-underscore-dangle,no-prototype-builtins */
/* eslint-disable no-param-reassign */
import axios from "axios";
import LocalStorageService from "./LocalStorageService";
import { getAuthRoute } from "../lib/routes";
import { getAuthOptions } from "./utils/getAuthOptions";

axios.interceptors.request.use((config) => {
  const token = LocalStorageService.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      error.config?.headers.hasOwnProperty("Content-Type")
    ) {
      LocalStorageService.clearToken();
      window.location.reload();
    }
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !error.config?.headers.hasOwnProperty("Content-Type")
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axios(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve) => {
        axios
          .post(
            getAuthRoute(),
            `grant_type=refresh_token&refresh_token=${LocalStorageService.getRefreshToken()}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                GrandType: "refresh_token",
              },
              auth: getAuthOptions(),
            }
          )
          .then((res) => {
            LocalStorageService.setToken(res?.data);
            axios.defaults.headers.common.Authorization = `Bearer ${LocalStorageService.getAccessToken}`;
            originalRequest.headers.Authorization = `Bearer ${LocalStorageService.getAccessToken}`;
            processQueue(null, LocalStorageService.getAccessToken);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            // reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  }
);
